import { LegalDocumentConfig } from "../../components/legal-document-viewer/types";

export const copyrightTrademarkContent: LegalDocumentConfig = {
  intro: {
    title: "Copyright, Trademark and Intellectual Property",
    subTitle: `Home Design Guild respects the intellectual property of others and expects users of the
Home Design Guild platform to do the same.`,
    description: [
      {
        title: `Process for Reporting Infringement`,
        description: [
          `As a Home Design Guild user, you are responsible for the content you upload and provide
to the Home Design Guild Platform. Home Design Guild’s Terms of Use and Acceptable
Use Policy do not allow posting, sharing, or sending any content that violates or infringes
someone else’s copyrights, trademarks, or other intellectual property rights. As set forth in
the Terms of Use, users who have uploaded content to the Home Design Guild Platform
have represented and warranted that they have all of the rights necessary to do so, and
grant Home Design Guild a license to the content to permit Home Design Guild to use it
on the Home Design Guild Platform.`,
          `If you believe your intellectual property has been infringed on the Home Design Guild
Platform, please complete the following electronic submission form for submission of
takedown requests for fastest processing: Infringement Claim Form. If you are unsure
whether the material you plan to report to us is infringing or otherwise violating another
person’s rights, you should seek legal advice before reporting such content to us, as false
or inaccurate reports could carry legal liability. If you infringe the copyrights or other intellectual property rights of others, content may
be removed or suspended in whole or part, consistent with this Policy and/or applicable
law.`,
        ],
      },
      {
        title: `Copyright Infringement Claims`,
        description: [
          `If you believe in good faith that materials hosted by Home Design Guild infringe your
copyright rights, you (or your agent) may utilize our Infringement Claim Form, requesting
that the material be removed, or access to it blocked. You must include the following
information: (a) a physical or electronic signature of a person authorized to act on behalf
of the owner of an exclusive right that is allegedly infringed; (b) identification of the
copyrighted work claimed to have been infringed (or if multiple copyrighted works located
on the Home Design Guild Platform are covered by a single notification, a representative
list of such works); (c) identification of the material that is claimed to be infringing or the
subject of infringing activity, and information reasonably sufficient to allow Home Design
Guild to locate the material on the Home Design Guild Platform; (d) information
reasonably sufficient to permit Home Design Guild to contact the complaining party, such
as the name, address, telephone number, and email address (if available) of the
complaining party; (e) a statement that the complaining party has a good faith belief that
use of the material in the manner complained of is not authorized by the copyright owner,
its agent, or the law; and (f) a statement that the information in the notification is accurate
and, under penalty of perjury, that the complaining party is authorized to act on behalf of
the owner of an exclusive right that is allegedly infringed. Home Design Guild is not
required to and may not respond to complaints that do not meet these requirements.
Home Design Guild may also ask for additional information related to your intellectual
property complaint and may also forward your complaint, including your email address
and name to the entities whose content you asked to be removed. These requirements
are guided by the Digital Millennium Copyright Act (the "DMCA") and similar laws in other
jurisdictions. All notices provided to Home Design Guild must be in machine-readable
format.`,
          `If you believe in good faith that a notice of copyright infringement has been wrongly filed
against you, the DMCA permits you to send us a counter-notice. Counter-notices must
include the following information: (a) your name, address, and telephone number; (b)
identification of the material that has been removed or to which access has been disabled,
and the location at which the material appeared before it was removed or access to it was
disabled; (c) a statement under penalty of perjury that you have a good faith belief that the content was removed or disabled as a result of a mistake or misidentification of the
material to be removed or disabled; (d) a statement that you consent to the jurisdiction of
the federal district court for the judicial district in which your address is located, or if your
address is outside of the United States, for any judicial district in which Home Design Guild
services may be found, and that you will accept service of process from the person who
provided the original complaint; and (e) a physical or electronic signature (for example,
typing your full name). Additional rights may apply to EU users via the Digital Services Act
for appeals.`,
          `Notices and counter-notices with respect to claims of copyright infringement on the Home
Design Guild Platform must meet the then-current statutory requirements imposed by the
DMCA (see http://www.loc.gov/copyright for details) and should be sent to the agent
identified below. We suggest that you consult your legal advisor before filing a notice or
counter-notice. Also, be aware that there can be penalties for false claims under the
DMCA.`,
        ],
      },
      {
        title: `Agent to Receive Notices of Claimed Infringement: NoReply@homedesignguild.com`,
        description: [
          `Upon receipt of a counter-notice, Home Design Guild may send a copy of the counter-
notice to the original complaining party, informing that party that Home Design Guild may
replace the removed content or cease disabling it. If Home Design Guild receives a valid
counter-notice, the removed content may be replaced or access to it restored by Home
Design Guild unless the copyright owner files an action seeking a court order against
Home Design Guild.`,
        ],
      },
      {
        title: `Other Intellectual Property Infringement Claims (Trademark, Patent & Trade Dress)`,
        description: [
          `If you believe in good faith that materials on the Home Design Guild Platform infringe
other intellectual property rights, such as trademark, patent, or trade dress infringement
rights, you (or your agent) may send us a notice requesting that the material be removed
or access to it blocked. The notice must include the following information: (a) a physical or
electronic signature of a person authorized to act on behalf of the owner of an exclusive
right that is allegedly infringed; (b) identification of the intellectual property right claimed
to have been infringed (or if multiple intellectual property located on the Home Design
Guild Platform are covered by a single notification, a representative list of registrations, as
an example); (c) identification of the material that is claimed to be infringing or the subject
of infringing activity, and information reasonably sufficient to allow Home Design Guild to
locate the material on the Home Design Guild Platform; (d) information reasonably
sufficient to permit Home Design Guild to contact the complaining party, such as the
name, address, telephone number, and email address (if available) of the complaining party; (e) a statement that the complaining party has a good faith belief that use of the
material in the manner complained of is not authorized by the intellectual property rights
owner, its agent, or the law; and (f) a statement that the information in the notification is
accurate and, under penalty of perjury, that the complaining party is authorized to act on
behalf of the owner of an exclusive right that is allegedly infringed. Home Design Guild
will not respond to complaints that do not meet these requirements. Home Design Guild
may also ask for additional information related to your intellectual property rights.`,
          `Note that Home Design Guild does not mediate intellectual property disputes between
third parties and rights owners. Should a third party contest an allegation you submitted
against them, Home Design Guild may forward the claim to the third party, with your
email address and contact information, with the intent that the third party and you may
resolve any dispute over ownership rights and/or infringement. Unlike a copyright
infringement violation, Home Design Guild will only reinstate or re-list content taken down
under intellectual property violations upon receipt of a retraction (sent to
noreply@homedesignguild.com) from the rights owner.`,
        ],
      },
      {
        title: `Repeat Infringement Policy`,
        description: [
          `Home Design Guild takes appropriate action against parties it categorizes as repeat
infringers. A repeat infringer includes, but is not limited to, anyone who qualifies as such
under the DMCA, or who receives multiple claims of IP infringement and such claims are
determined by Home Design Guild to be valid. It is our policy, in appropriate
circumstances and our discretion, to disable and/or terminate accounts of users who
repeatedly infringe or are charged repeatedly with infringing the intellectual property
rights of others.`,
        ],
      },
      {
        title: `Reporting Suspicious Activity`,
        description: [
          `If you see suspicious activity on Home Design Guild Platform or its entities, including
illegal content pursuant to the Digital Services Act, please notify us via email at
NoReply@homedesignguild.com
`,
        ],
      },
    ],
  },
};
